import { Controller, useFormContext } from 'react-hook-form';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { format, parse } from 'date-fns';

interface RHFTimePickerProps {
  name: string;
  label: string;
  helperText?: string;
  disabled?: boolean;
}

export default function RHFTimePicker({ name, label, helperText, disabled }: RHFTimePickerProps) {
  const { control, watch } = useFormContext();
  const timeValue = watch(name);

  // Convert string time to Date object for TimePicker
  const parseTimeString = (timeString: string) => {
    if (!timeString) return null;
    try {
      return parse(timeString, 'HH:mm', new Date());
    } catch (error) {
      return null;
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TimePicker
          label={label}
          value={parseTimeString(field.value)}
          onChange={(newValue) => {
            const timeString = newValue ? format(newValue, 'HH:mm') : '';
            field.onChange(timeString);
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error ? error?.message : helperText,
              disabled,
            },
          }}
        />
      )}
    />
  );
}